import * as React from "react";

const { Component } = React;

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import * as AccountStore from "../account/AccountStore";
import { Link } from "react-router-dom";
import * as ApplicationsStore from "../applications/ApplicationsStore";
import { ApplicationCard } from "../general/ApplicationCard";

let contextSubscriptionId = "";

let now = new Date();

let timeOfDay = now.getHours() < 12 ? "Morning" : now.getHours() < 18 ? "Afternoon" : "Evening";

interface HomeState {
    isLoading: boolean;
    organizationId: string;
    currentUser: any;
    apps: Array<any>;
    showDisabledTooltip: boolean;
    zammadChat: any;
}

export default class HomeIndex extends Component<any, HomeState> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            organizationId: "",
            currentUser: {},
            apps: [],
            showDisabledTooltip: false,
            zammadChat: null,
        };
    }

    componentDidMount() {
        AccountStore.GetCurrentLoggedInUser().then((user) => {
            this.setState({ currentUser: user, isLoading: false });
        });

        contextSubscriptionId = GetContext((context) => {
            this.setState({ organizationId: context.currentOrganization.id });

            this.loadApps();
        });

        this.setState({
            zammadChat: new ZammadChat({
                fontSize: "12px",
                chatId: 1,
                show: true,
                debug: true,
            }),
        });
    }

    loadApps = () => {
        this.setState({ apps: [] });
        ApplicationsStore.LoadMyApps().then((response) => {
            this.setState({
                apps: response,
            });
        });
    };

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    toggleDisabledTooltip = () => {
        this.setState((prevState) => ({ showDisabledTooltip: !prevState.showDisabledTooltip }));
    };

    render() {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
                {!this.state.isLoading && (
                    <>
                        <OrganizationContextSwitcher></OrganizationContextSwitcher>

                        <div className="container mx-auto px-4 py-8 max-w-7xl">
                            {/* Hero Section */}
                            <div className="text-center mb-12">
                                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full mb-6 shadow-lg">
                                    <FontAwesomeIcon icon={["fad", "home"]} className="text-white text-2xl" />
                                </div>
                                <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 leading-tight">
                                    Good {timeOfDay}, <br />
                                    <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                                        {this.state.currentUser.firstName || this.state.currentUser.fullName}
                                    </span>
                                </h1>
                                <p className="text-lg text-gray-600 max-w-2xl mx-auto">Welcome back! Access your applications and manage your workspace from your personalized dashboard.</p>
                            </div>

                            {/* Applications Grid */}
                            {this.state.apps.length > 0 ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
                                    {this.state.apps.map((app, i) => (
                                        <ApplicationCard key={i} app={app}></ApplicationCard>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-20">
                                    <div className="relative inline-flex items-center justify-center w-28 h-28 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl mb-8 shadow-lg">
                                        <div className="absolute inset-0 bg-gradient-to-br from-white/60 to-transparent rounded-3xl"></div>
                                        <FontAwesomeIcon icon={["fad", "th-large"]} className="relative z-10 text-gray-400 text-4xl drop-shadow-sm" />
                                    </div>
                                    <h3 className="text-2xl font-bold text-gray-700 mb-3">No Applications Available</h3>
                                    <p className="text-gray-500 max-w-md mx-auto leading-relaxed">
                                        You don't have any applications assigned yet. Contact your administrator to get access to your workspace applications.
                                    </p>
                                    <div className="mt-8">
                                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-xl text-sm font-medium">
                                            <FontAwesomeIcon icon={["fad", "info-circle"]} className="text-blue-500" />
                                            <span>Need help? Contact support</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* Loading State */}
                {this.state.isLoading && (
                    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
                        <div className="text-center">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                            <p className="text-gray-600 text-lg">Loading your dashboard...</p>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
